import React, { useState, useRef, useEffect } from "react";
import {
	Box,
	Typography,
	Button,
	Grid,
	Modal,
	CircularProgress,
	TextField,
} from "@mui/material";
import EditTextModal from "../EditTextModal/EditTextModal";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import TemplateImage from "../../assets/templates/template-3.png";
import Map from "../Map/Map";

const Template4 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const [selectedTextIndex, setSelectedTextIndex] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalText, setModalText] = useState("");

	const handleTextClick = (index) => {
		setSelectedTextIndex(index);
		setModalText(page.texts[index].content);
		setIsModalOpen(true);
	};

	const handleModalTextChange = (value) => {
		setModalText(value);
	};

	const handleModalSave = () => {
		let auxPage = { ...page };
		auxPage.texts[selectedTextIndex] = {
			content: modalText,
			isEditing: false,
		};
		updatePage({ ...auxPage });

		setIsModalOpen(false);
	};

	const handleModalCancel = () => {
		setIsModalOpen(false);
	};
	return (
		<Box
			sx={{
				backgroundColor: backgroundColor,
				display: "flex",
				width: "100%",
				height: "100%",
				flexDirection: "column",
				"& *": {
					fontFamily: fontFamily + "!important",
				},
				position: "relative",
			}}
		>
			<Box
				data-template-item="true"
				data-block-id="header"
				onClick={() => handleTextClick(0)}
				style={{
					height: "51px",
					minHeight: "51px",
					width: "100%",
					backgroundColor: headerBackgroundColor,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					textAlign: "center",
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				<Typography
					data-template-item="true"
					onClick={() => handleTextClick(0)}
					sx={{
						display: "flex!important",
						justifyContent: "center",
						height: "100%",
						alignItems: "center",
						color: headerTextColor,
						cursor: "pointer",
						textAlign: "center",
						fontSize: "14px!important",
						fontWeight: "bold!important",
					}}
					dangerouslySetInnerHTML={{ __html: page.texts[0].content || "Título de la página" }}
				/>
			</Box>

			<Box data-block-id="map" sx={{ flex: 1 }}>
				<Map page={page} updatePage={updatePage} index={0} />
			</Box>

			<EditTextModal
				showModal={isModalOpen}
				handleClose={handleModalCancel}
				value={modalText}
				onChange={handleModalTextChange}
				onSave={handleModalSave}
			/>
		</Box>
	);
};

Template4.thumbnail = TemplateImage;

export default Template4;
